import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Link } from "react-router-dom";

import { Tab, Box } from '@mui/material';
import { TabList } from '@mui/lab';

type ParamsStyle = {
    theme?: Theme;
}

export const LinkButton = styled(Link)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        height: 2.5rem;
        border-radius: 5px;
        text-aling: center;
        align-items: center;
        justify-content: center;
        border: 2px solid ${theme?.palette.primary.main};

        font-size: 1rem;
        font-weight: 700;
        color: ${theme?.palette.primary.main};
`);

export const BoxBanner = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 1.5rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: auto;
        display: flex;
        max-width: 14.5rem;
        padding-bottom: 0;
    }
`);

export const TabListCustom = styled(TabList)(
    ({ theme }: ParamsStyle) => `
    .MuiTabs-flexContainer {
        display: grid;
        gap: .5rem;
        grid-template-columns: 1fr 1fr;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        .MuiTabs-flexContainer {
            display: flex;
        }   
    }
`);

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    .MuiTabs-indicator {
        height: 5.75px;
        border-radius: 12px;
        background-color: ${theme?.palette.secondary.main};
    }

    .MuiTabs-flexContainer {
        gap: 0;
        padding: 1.75rem 0 1rem;
        justify-content: space-between;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        .MuiTabs-flexContainer {
            gap: 2.75rem;
            padding: 1.75rem 0 1rem;
            justify-content: flex-start;
        }
    }
`);

export const TabCustom = styled(Tab)(
    ({ theme }: ParamsStyle) => `
        border-radius: 12px;
        width: 100%;
        font-weight: 600;
        height: 5.9375rem;
        font-size: .75rem;
        text-transform: none;
        border: 1.83622px solid rgba(12, 28, 51, 0.5);

        &.Mui-selected {
            color: white;
            background: ${theme?.palette.primary.main};

            svg {
                path {
                    stroke: white;
                }
                
                circle {
                    stroke: white;
                }
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 8.124rem;
            font-size: .875rem;
        }
`);

export const BannerContent = styled.div(`
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-top: .8rem;

    img {
        width: 100%;
        height: auto;
        max-width: 100%;
        border-radius: 20px;
        background-size: cover;
    }

    button {
        width: 117px;
        height: 30px;
        font-size: .75rem;
        padding: 0;
        position: absolute;
    }

    a {
        position: absolute;
        width: 120px;
        height: 40px;
        cursor: pointer;

        &.apple {
            bottom: 84px;
        }

        &.android {
            bottom: 28px;
        }
    }
`);